<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <!-- <el-form-item>
          <el-input v-model="filters.name" placeholder="用户名"></el-input>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" v-on:click="getClerks">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>-->
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="mobile" label="手机"></el-table-column>
      <el-table-column prop="hotel_id" label="酒店">
        <template scope="scope">
          <el-button type="text" @click="()=>showHotel(scope)">查看酒店</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="role"
        label="角色"
        :formatter="formatRole"
      ></el-table-column>

      <el-table-column label="操作" width="150">
        <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="handleDel(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >-->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            disabled
            v-model="editForm.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="name">
          <el-input
            disabled
            v-model="editForm.mobile"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="editForm.role" clearable>
            <el-option label="审核不通过" :value="0"></el-option>
            <el-option label="店员" :value="1"></el-option>
            <el-option label="店长" :value="2"></el-option>
            <el-option label="销售员" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="酒店" prop="hotel_id" v-if="editForm.role !== 3">
          <el-select filterable v-model="editForm.hotel_id" clearable class="long-select">
            <el-option
              :label="`${hotel.tzName ? hotel.tzName : ''}--${
                hotel.dltName ? hotel.dltName : ''
              }`"
              :value="hotel.id"
              v-for="hotel in hotels"
              :key="hotel.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="酒店" prop="hotel_ids" v-if="editForm.role === 3">
          <el-select
            v-model="editForm.hotel_ids"
            clearable
            multiple
            class="long-select"
            filterable
          >
            <el-option
              :label="`${hotel.tzName ? hotel.tzName : ''}--${
                hotel.dltName ? hotel.dltName : ''
              }`"
              :value="hotel.id"
              v-for="hotel in hotels"
              :key="hotel.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="酒店名" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="addForm.address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="银行卡" prop="bank_card">
          <el-input v-model="addForm.bank_card" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="查看酒店" v-model="modalVisible">
      <el-table :data="roleHotels" >
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="tzName" label="同舟酒店名"></el-table-column> 
        <el-table-column prop="dltName" label="代理通酒店名"></el-table-column>      
        <el-table-column prop="tcName" label="同程酒店名"></el-table-column>  
        <el-table-column prop="pigName" label="飞猪酒店名"></el-table-column>          
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideModal">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../common/js/util";
import NProgress from "nprogress";
import { hotelApi, auditApi } from "../../api/api";
import { roleMap as role } from "../../constant";

export default {
  data() {
    return {
      filters: {
        name: "",
      },
      hotels: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        //   role: [{ required: true, message: '请输入角色', trigger: 'blur' }],
      },
      //编辑界面数据
      editForm: {
        name: "",
        mobile: "",
        hotel_id: "",
        role: "",
        hotel_ids: [],
        id: "",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        bank_card: [
          { required: true, message: "请输入银行卡信息", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        address: "",
        bank_card: "",
      },
      modalVisible: false,
      roleHotels: [],
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getClerks();
    },
    getHotels() {
      let para = {
        type: "all",
      };
      NProgress.start();
      hotelApi.list(para).then((res) => {
        this.hotels = res.data.rows;
        this.listLoading = false;
        NProgress.done();
      });
    },
    formatHotel(row) {
      if (row.role === 3) {
        return row.hotel_ids.reduce((prev, hotel_id) => {
          const found = this.hotels.find(({ id }) => id === hotel_id);
          return prev + (found && `${found.tzName}-${found.dltName}`) + "；";
        }, "");
      }
      const found = this.hotels.find(({ id }) => id === row.hotel_id);

      return (found && `${found.tzName}-${found.dltName}`) || "-";
    },
    showHotel(scope) {
      const row = scope.row
      if(row.role===3){
        this.roleHotels = this.hotels.filter(i=> row.hotel_ids.includes(i.id))
      }
      const found = this.hotels.find(({ id }) => id === row.hotel_id);
      if(found){
        this.roleHotels = [found]
      }
      this.modalVisible = true;
    },
    hideModal(){
      this.roleHotels = []
      this.modalVisible = false
    },
    
    formatRole(row) {
      return role[row.role];
    },
    getClerks() {
      let para = {
        page: this.page,
      };
      this.listLoading = true;
      NProgress.start();
      auditApi.list(para).then((res) => {
        this.total = res.data.count;
        this.users = res.data.rows;
        console.log(res.data.rows);
        this.listLoading = false;
        NProgress.done();
      });
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          NProgress.start();
          let para = { id: row.id };
          auditApi.del(para).then((res) => {
            this.listLoading = false;
            NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getClerks();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign(this.editForm, row);
    },
    //显示新增界面
    handleAdd: function () {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        address: "",
        bank_card: "",
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            const { id, hotel_id, mobile, role, hotel_ids } = this.editForm;
            let para = { id, hotel_id, mobile, role, hotel_ids };
            auditApi.update(para).then((res) => {
              this.editLoading = false;
              //NProgress.done();
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getClerks();
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            //   para.birth =
            //     !para.birth || para.birth == ''
            //       ? ''
            //       : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
            hotelApi.add(para).then((res) => {
              this.addLoading = false;
              //NProgress.done();
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.getHotels();
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      var ids = this.sels.map((item) => item.id).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };
          batchRemoveUser(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getHotels();
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getHotels();
    this.getClerks();
  },
};
</script>

<style scoped>
.long-select {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// index.vue?51770558